import configs from './config.json';
import {Api} from "./Api";
import {UserApi} from "./UserApi";

export class SettingApi {
    static getSetting = async ( response, error) => {
        await Api.get(`setting`, null, response, configs.requestHeader, error);
    }

    static getSetting2 = async ( response, error) => {
        await Api.get(`setting2`, null, response, configs.requestHeader, error);
    }

    static updateSetting = async (data, response, error) => {
        await Api.post(`setting`, data, response, UserApi.getAuthorizedHeader(), error);
    }


}